module.exports = __webpack_public_path__ + "static/media/chevron-down.1c43fffe.svg";